/**
 * Primary brand mark for Jama Masjid Dariyapur.
 *
 * The mark is the corner minaret tower + three cusped arches of the Dariyapur
 * facade arcade — drawn from the real building's signature, not invented.
 * No dome, no crescent, no bulb-topped minaret.
 *
 * Source of truth for all SVG path data. LogoIcon and BrandLockup re-render
 * the same paths at different scales.
 */
interface Props {
  /** Fill color for the mark. Default: brand teal #3D8C84. Pass "currentColor" to inherit. */
  color?: string;
  className?: string;
  /** When provided, the mark is rendered as `role="img"` with this label. Otherwise aria-hidden. */
  title?: string;
}

export function LogoMark({ color = "#3D8C84", className, title }: Props) {
  return (
    <svg
      viewBox="0 0 320 220"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <g fill={color}>
        <rect x="60" y="78" width="40" height="32" />
        <rect x="66" y="68" width="28" height="10" />
        <path d="M 68 68 L 80 54 L 92 68 Z" />
        <circle cx="80" cy="50" r="2.5" />
        <path
          fillRule="evenodd"
          d="M 30 190 L 30 110 L 290 110 L 290 190 Z M 50 190 L 50 148 Q 50 140 58 138 L 66 130 L 72 136 L 80 120 L 88 136 L 94 130 L 102 138 Q 110 140 110 148 L 110 190 Z M 130 190 L 130 148 Q 130 140 138 138 L 146 130 L 152 136 L 160 120 L 168 136 L 174 130 L 182 138 Q 190 140 190 148 L 190 190 Z M 210 190 L 210 148 Q 210 140 218 138 L 226 130 L 232 136 L 240 120 L 248 136 L 254 130 L 262 138 Q 270 140 270 148 L 270 190 Z"
        />
      </g>
    </svg>
  );
}
